// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MarkdownEditorController from "./markdown_editor_controller"
application.register("markdown-editor", MarkdownEditorController)

import ReplyComposerController from "./reply_composer_controller"
application.register("reply-composer", ReplyComposerController)

import ShowcaseMediaUploadController from "./showcase_media_upload_controller"
application.register("showcase-media-upload", ShowcaseMediaUploadController)

import WebPushController from "./web_push_controller"
application.register("web-push", WebPushController)
